// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// // import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
// // import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
// import { useThemeMode } from '../../../_metronic/partials'


// type Props = {
//     className: string
//     chartColor: string
//     chartHeight: string
//     data?: any
//     title?: string
//     subtitle?: string
//     amount?: string
// }

// const MixedWidget16: React.FC<Props> = ({
//     className,
//     chartColor,
//     chartHeight,
//     data,
//     title = 'Impact',
//     subtitle = 'Yearly Performance',
//     amount = '$0'
// }) => {
//     const chartRef = useRef<HTMLDivElement | null>(null)
//     const { mode } = useThemeMode()

//     const refreshChart = () => {
//         if (!chartRef.current) {
//             return
//         }

//         const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, data))
//         if (chart) {
//             chart.render()
//         }

//         return chart
//     }

//     useEffect(() => {
//         const chart = refreshChart()

//         return () => {
//             if (chart) {
//                 chart.destroy()
//             }
//         }
//     }, [chartRef, mode, data])

//     return (
//         <div className={`card ${className}`}>
//             <div className='card-body p-0 d-flex justify-content-between flex-column overflow-hidden'>
//                 <div className='d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3'>
//                     <div className='me-2'>
//                         <span className='fw-bold text-gray-800 d-block fs-3'>{title}</span>
//                         <span className='text-gray-400 fw-semibold'>{subtitle}</span>
//                     </div>
//                     <div className={`fw-bold fs-3 text-${chartColor}`}>{amount}</div>
//                 </div>

//                 <div ref={chartRef} className='mixed-widget-16-chart'></div>
//             </div>
//         </div>
//     )
// }

// const chartOptions = (chartColor: string, chartHeight: string, data?: any): ApexOptions => {
//     const labelColor = getCSSVariableValue('--bs-gray-500')
//     const borderColor = getCSSVariableValue('--bs-gray-200')
//     const secondaryColor = getCSSVariableValue('--bs-gray-300')
//     const tertiaryColor = getCSSVariableValue('--bs-gray-400')
//     const baseColor = getCSSVariableValue('--bs-' + chartColor)

//     const hasSeries3 = data?.series3 && data.series3.length > 0

//     const series = [
//         {
//             name: 'Collected',
//             data: data?.series1 || [0],
//         },
//         {
//             name: 'Recycled',
//             data: data?.series2 || [0],
//         },
//         {
//             name: 'Sold',
//             data: data?.series3 || [0],
//         },
//     ]

//     const yaxisConfig = {
//         labels: {
//             style: {
//                 colors: labelColor,
//                 fontSize: '12px',
//             },
//             formatter: function (val: number) {
//                 return Math.round(val).toString()
//             }
//         }
//     }

//     return {
//         series: series,
//         chart: {
//             fontFamily: 'inherit',
//             type: 'bar',
//             height: chartHeight,
//             toolbar: {
//                 show: false,
//             },
//         },
//         plotOptions: {
//             bar: {
//                 horizontal: false,
//                 columnWidth: '55%',
//                 borderRadius: 5,
//             },
//         },
//         legend: {
//             show: true,
//             position: 'top',
//             labels: {
//                 fontSize: '12px',
//                 colors: [labelColor],
//             },
//         } as any,
//         dataLabels: {
//             enabled: false,
//         },
//         stroke: {
//             show: true,
//             width: 2,
//             colors: ['transparent'],
//         },
//         xaxis: {
//             categories: data?.categories || ['2024', '2025'],
//             axisBorder: {
//                 show: false,
//             },
//             axisTicks: {
//                 show: false,
//             },
//             labels: {
//                 style: {
//                     colors: labelColor,
//                     fontSize: '12px',
//                 },
//             },
//         },
//         yaxis: yaxisConfig as any,
//         fill: {
//             type: 'solid',
//         },
//         states: {
//             normal: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             hover: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             active: {
//                 allowMultipleDataPointsSelection: false,
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//         },
//         tooltip: {
//             style: {
//                 fontSize: '12px',
//             },
//             y: {
//                 formatter: function (val: number, { seriesIndex }: any) {
//                     if (seriesIndex === 0) {
//                         return val.toFixed(2) + ' Kg'
//                     } else if (seriesIndex === 1) {
//                         return '₹' + val.toFixed(2)
//                     } else if (seriesIndex === 2) {
//                         return val.toFixed(2) + ' Kg'
//                     }
//                     return val.toFixed(2)
//                 },
//             },
//         },
//         colors: [baseColor, secondaryColor, tertiaryColor],
//         grid: {
//             padding: {
//                 top: 10,
//             },
//             borderColor: borderColor,
//             strokeDashArray: 4,
//             yaxis: {
//                 lines: {
//                     show: true,
//                 },
//             },
//         },
//     } as ApexOptions
// }

// export { MixedWidget16 }





// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
// import { useThemeMode } from '../../../_metronic/partials'

// type Props = {
//     className: string
//     chartColor: string
//     chartHeight: string
//     data?: any
//     title?: string
//     subtitle?: string
//     amount?: string
// }

// const MixedWidget16: React.FC<Props> = ({
//     className,
//     chartColor,
//     chartHeight,
//     data,
//     title = 'Impact',
//     subtitle = 'Yearly Performance',
//     amount = '$0',
// }) => {
//     const chartRef = useRef(null)
//     const { mode } = useThemeMode()

//     const refreshChart = () => {
//         if (!chartRef.current) {
//             return
//         }

//         const chart = new ApexCharts(
//             chartRef.current,
//             chartOptions(chartColor, chartHeight, data)
//         )
//         if (chart) {
//             chart.render()
//         }
//         return chart
//     }

//     useEffect(() => {
//         const chart = refreshChart()
//         return () => {
//             if (chart) {
//                 chart.destroy()
//             }
//         }
//     }, [chartRef, mode, data])

//     return (
//         <div className={`card ${className}`}>
//             <div className="card-body d-flex flex-column">
//                 <div className="d-flex align-items-start justify-content-between mb-2">
//                     <div className="d-flex flex-column">
//                         <a href="#" className="text-gray-900 text-hover-primary fw-bold fs-4">
//                             {title}
//                         </a>
//                         <span className="text-gray-500 fw-semibold fs-7">{subtitle}</span>
//                     </div>
//                 </div>

//                 <div ref={chartRef} />
//             </div>
//         </div>
//     )
// }

// const chartOptions = (
//     chartColor: string,
//     chartHeight: string,
//     data?: any
// ): ApexOptions => {
//     const labelColor = getCSSVariableValue('--bs-gray-500')
//     const borderColor = getCSSVariableValue('--bs-gray-200')
//     const secondaryColor = getCSSVariableValue('--bs-gray-300')
//     const baseColor = getCSSVariableValue('--bs-' + chartColor)

//     const series = [
//         {
//             name: 'Count',
//             data: data?.series1 || [0],
//         },
//         {
//             name: 'Quantity',
//             data: data?.series2 || [0],
//         },
//     ]

//     const yaxisConfigLeft = {
//         seriesName: 'Count',
//         axisTicks: {
//             show: false,
//         },
//         axisBorder: {
//             show: false,
//         },
//         labels: {
//             style: {
//                 colors: baseColor,
//                 fontSize: '12px',
//             },
//             formatter: function (val: number) {
//                 return Math.round(val).toString()
//             },
//         },
//         title: {
//             text: '',
//         },
//     }

//     const yaxisConfigRight = {
//         seriesName: 'Quantity',
//         opposite: true,
//         axisTicks: {
//             show: false,
//         },
//         axisBorder: {
//             show: false,
//         },
//         labels: {
//             style: {
//                 colors: secondaryColor,
//                 fontSize: '12px',
//             },
//             formatter: function (val: number) {
//                 return Math.round(val).toString()
//             },
//         },
//         title: {
//             text: '',
//         },
//     }

//     return {
//         series: series,
//         chart: {
//             fontFamily: 'inherit',
//             type: 'bar',
//             height: chartHeight,
//             toolbar: {
//                 show: false,
//             },
//         },
//         plotOptions: {
//             bar: {
//                 horizontal: false,
//                 columnWidth: '55%',
//                 borderRadius: 5,
//             },
//         },
//         legend: {
//             show: true,
//             position: 'top',
//             labels: {
//                 colors: labelColor,
//             },
//         },
//         dataLabels: {
//             enabled: false,
//         },
//         stroke: {
//             show: true,
//             width: 2,
//             colors: ['transparent'],
//         },
//         xaxis: {
//             categories: data?.categories || Array.from({ length: 31 }, (_, i) => (i + 1).toString()),
//             axisBorder: {
//                 show: false,
//             },
//             axisTicks: {
//                 show: false,
//             },
//             labels: {
//                 style: {
//                     colors: labelColor,
//                     fontSize: '12px',
//                 },
//             },
//         },
//         yaxis: [yaxisConfigLeft, yaxisConfigRight] as any,
//         fill: {
//             type: 'solid',
//         },
//         states: {
//             normal: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             hover: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             active: {
//                 allowMultipleDataPointsSelection: false,
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//         },
//         tooltip: {
//             style: {
//                 fontSize: '12px',
//             },
//             y: {
//                 formatter: function (val: number, { seriesIndex }: any) {
//                     if (seriesIndex === 0) {
//                         return Math.round(val).toString()
//                     } else if (seriesIndex === 1) {
//                         return Math.round(val).toString() + ' Kg'
//                     }
//                     return val.toFixed(2)
//                 },
//             },
//         },
//         colors: [baseColor, secondaryColor],
//         grid: {
//             padding: {
//                 top: 10,
//             },
//             borderColor: borderColor,
//             strokeDashArray: 4,
//             yaxis: {
//                 lines: {
//                     show: true,
//                 },
//             },
//         },
//     } as ApexOptions
// }

// export { MixedWidget16 }


import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../_metronic/partials'

type Props = {
    className: string
    chartColor: string
    chartHeight: string
    data?: any
    title?: string
    subtitle?: string
    amount?: string
}

const MixedWidget16: React.FC<Props> = ({
    className,
    chartColor,
    chartHeight,
    data,
    title = 'Impact',
    subtitle = 'Yearly Performance',
    amount = '$0',
}) => {
    const chartRef = useRef(null)
    const { mode } = useThemeMode()

    const refreshChart = () => {
        if (!chartRef.current) {
            return
        }

        const chart = new ApexCharts(
            chartRef.current,
            chartOptions(chartColor, chartHeight, data)
        )
        if (chart) {
            chart.render()
        }
        return chart
    }

    useEffect(() => {
        const chart = refreshChart()
        return () => {
            if (chart) {
                chart.destroy()
            }
        }
    }, [chartRef, mode, data])

    return (
        <div className={`card ${className}`}>
            <div className="card-body d-flex flex-column">
                <div className="d-flex align-items-start justify-content-between mb-2">
                    <div className="d-flex flex-column">
                        <a href="#" className="text-gray-900 text-hover-primary fw-bold fs-4">
                            {title}
                        </a>
                        <span className="text-gray-500 fw-semibold fs-7">{subtitle}</span>
                    </div>
                </div>

                <div ref={chartRef} />
            </div>
        </div>
    )
}

const chartOptions = (
    chartColor: string,
    chartHeight: string,
    data?: any
): ApexOptions => {
    const labelColor = getCSSVariableValue('--bs-gray-500')
    const borderColor = getCSSVariableValue('--bs-gray-200')
    const secondaryColor = getCSSVariableValue('--bs-gray-300')
    const baseColor = getCSSVariableValue('--bs-' + chartColor)

    const series = [
        {
            name: 'Count',
            data: data?.series1 || [0],
        },
        {
            name: 'Quantity',
            data: data?.series2 || [0],
        },
    ]

    // Extract only day from date strings like "2026-01-09" -> "9"
    const categories = (data?.categories || []).map((dateStr: string) => {
        if (dateStr && dateStr.includes('-')) {
            const day = dateStr.split('-')[2]
            return parseInt(day, 10).toString() // Remove leading zero
        }
        return dateStr
    })

    const yaxisConfigLeft = {
        seriesName: 'Count',
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            style: {
                colors: baseColor,
                fontSize: '12px',
            },
            formatter: function (val: number) {
                return Math.round(val).toString()
            },
        },
        title: {
            text: '',
        },
    }

    const yaxisConfigRight = {
        seriesName: 'Quantity',
        opposite: true,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            style: {
                colors: secondaryColor,
                fontSize: '12px',
            },
            formatter: function (val: number) {
                return Math.round(val).toString()
            },
        },
        title: {
            text: '',
        },
    }

    return {
        series: series,
        chart: {
            fontFamily: 'inherit',
            type: 'bar',
            height: chartHeight,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 5,
            },
        },
        legend: {
            show: true,
            position: 'top',
            labels: {
                colors: labelColor,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: categories,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        yaxis: [yaxisConfigLeft, yaxisConfigRight] as any,
        fill: {
            type: 'solid',
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val: number, { seriesIndex }: any) {
                    if (seriesIndex === 0) {
                        return Math.round(val).toString()
                    } else if (seriesIndex === 1) {
                        return Math.round(val).toLocaleString('en-In') + ' Kg'
                    }
                    return val.toFixed(2)
                },
            },
        },
        colors: [baseColor, secondaryColor],
        grid: {
            padding: {
                top: 10,
            },
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
    } as ApexOptions
}

export { MixedWidget16 }